import Vue from "vue";

const state = {
  data: [],

  templateConfigs: {
    appointment: [
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "created",
        target: "customer",
        title: "Appointment Created SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "created",
        target: "customer",
        title: "Appointment (Phone Consult) Created SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "created",
        target: "user",
        title: "Appointment Created SMS to Tech User",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "created",
        target: "user",
        title: "Appointment (Phone Consult) Created SMS to Tech User",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "assistant_created",
        target: "user",
        title: "Appointment Created SMS to Assistant",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "assistant_created",
        target: "user",
        title: "Appointment (Phone Consult) Created SMS to Assistant",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "deleted",
        target: "customer",
        title: "Appointment Deleted SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "deleted",
        target: "customer",
        title: "Appointment (Phone Consult) Deleted SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "deleted",
        target: "user",
        title: "Appointment Deleted SMS to Tech User",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "deleted",
        target: "user",
        title: "Appointment (Phone Consult) Deleted SMS to Tech User",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "assistant_deleted",
        target: "user",
        title: "Appointment Deleted SMS to Assistant",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "assistant_deleted",
        target: "user",
        title: "Appointment (Phone Consult) Deleted SMS to Assistant",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "updated",
        target: "customer",
        title: "Appointment Updated SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "updated",
        target: "customer",
        title: "Appointment (Phone Consult) Updated SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "updated",
        target: "user",
        title: "Appointment Updated SMS to Tech User",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "updated",
        target: "user",
        title: "Appointment (Phone Consult) Updated SMS to Tech User",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "assistant_updated",
        target: "user",
        title: "Appointment Updated SMS to Assistant",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "assistant_updated",
        target: "user",
        title: "Appointment (Phone Consult) Updated SMS to Assistant",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "reminder",
        target: "customer",
        title: "Appointment Reminder SMS to Customer",
        subtitle: "Sent the day before a scheduled appointment",
      },
      {
        channel: "message",
        category: "appointment.phone_consult",
        name: "reminder",
        target: "customer",
        title: "Appointment (Phone Consult) Reminder SMS to Customer",
        subtitle: "Sent the day before a scheduled phone consult",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "travelling",
        target: "customer",
        title: "Travel started SMS to Customer",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "travellingfuzzy",
        target: "customer",
        title: "Travel started SMS to Customer",
        subtitle: "When unable to provide travel estimate",
      },
      {
        channel: "message",
        category: "appointment.site_visit",
        name: "travellingtest",
        target: "customer",
        title: "Travel started SMS to Customer (TEST)",
        subtitle: "LEAVE THIS ALONE, TESTING ONLY",
      },
      {
        channel: "email",
        category: "appointment.site_visit",
        name: "remindersubject",
        target: "customer",
        title: "Email Subject for Appointment Reminder to Customer",
        subtitle: "Sent the day before a scheduled appointment",
        type: "text",
      },
      {
        channel: "email",
        category: "appointment.phone_consult",
        name: "remindersubject",
        target: "customer",
        title: "Email Subject for Appointment (Phone Consult) Reminder to Customer",
        subtitle: "Sent the day before a scheduled phone consult",
        type: "text",
      },
      {
        channel: "email",
        category: "appointment.site_visit",
        name: "reminder",
        target: "customer",
        title: "Appointment Reminder Email to Customer",
        subtitle: "Sent the day before a scheduled appointment",
      },
      {
        channel: "email",
        category: "appointment.phone_consult",
        name: "reminder",
        target: "customer",
        title: "Appointment (Phone Consult) Reminder Email to Customer",
        subtitle: "Sent the day before a scheduled phone consult",
      },
      {
        channel: "email",
        category: "appointment.site_visit",
        name: "reminder7dayssubject",
        target: "customer",
        title: "Email Subject for 1 Week Reminder to Customer",
        type: "text",
      },
      {
        channel: "email",
        category: "appointment.phone_consult",
        name: "reminder7dayssubject",
        target: "customer",
        title: "Email Subject for 1 Week Reminder to Customer (Phone Consult)",
        type: "text",
      },
      {
        channel: "email",
        category: "appointment.site_visit",
        name: "reminder7days",
        target: "customer",
        title: "1 Week Reminder Email to Customer",
      },
      {
        channel: "email",
        category: "appointment.phone_consult",
        name: "reminder7days",
        target: "customer",
        title: "1 Week Reminder Email to Customer (Phone Consult)",
      },
      {
        channel: "email",
        category: "appointment.site_visit",
        name: "createdsubject",
        target: "customer",
        title: "Email Subject for Appointment Created",
        type: "text",
      },
      {
        channel: "email",
        category: "appointment.phone_consult",
        name: "createdsubject",
        target: "customer",
        title: "Email Subject for Appointment (Phone Consult) Created",
        type: "text",
      },
      {
        channel: "email",
        category: "appointment.site_visit",
        name: "created",
        target: "customer",
        title: "Appointment Created Email to Customer",
      },
      {
        channel: "email",
        category: "appointment.phone_consult",
        name: "created",
        target: "customer",
        title: "Appointment (Phone Consult) Created Email to Customer",
      },
    ],

    invoice: [
      {
        channel: "message",
        category: "invoice",
        name: "quoted",
        target: "customer",
        title: "Quote Notice SMS to Customer",
      },
      {
        channel: "message",
        category: "invoice",
        name: "notice",
        target: "customer",
        title: "Invoice Notice SMS to Customer",
      },
      {
        channel: "email",
        category: "invoice",
        name: "quotedsubject",
        target: "customer",
        title: "Email Subject for Quote Notice to Customer",
        type: "text",
      },
      {
        channel: "email",
        category: "invoice",
        name: "quoted",
        target: "customer",
        title: "Quote Notice Email to Customer",
      },
      {
        channel: "email",
        category: "invoice",
        name: "noticesubject",
        target: "customer",
        title: "Email Subject for Invoice Notice to Customer",
        type: "text",
      },
      {
        channel: "email",
        category: "invoice",
        name: "notice",
        target: "customer",
        title: "Invoice Notice Email to Customer",
      },
      {
        channel: "email",
        category: "invoice",
        name: "paidsubject",
        target: "customer",
        title: "Email Subject for Invoice Paid to Customer",
        type: "text",
      },
      {
        channel: "email",
        category: "invoice",
        name: "paid",
        target: "customer",
        title: "Invoice Paid Email to Customer",
      },
      {
        channel: "email",
        category: "invoice",
        name: "refundedsubject",
        target: "customer",
        title: "Email Subject for Invoice Refunded to Customer",
        type: "text",
      },
      {
        channel: "email",
        category: "invoice",
        name: "refunded",
        target: "customer",
        title: "Invoice Refunded Email to Customer",
      },
      {
        channel: "email",
        category: "invoice",
        name: "quoteacceptedsubject",
        target: "admin",
        title: "Email Subject for Quote Accepted to Admin",
        type: "text",
      },
      {
        channel: "email",
        category: "invoice",
        name: "quoteaccepted",
        target: "admin",
        title: "Quote Accepted Email to Admin",
      },
    ],
  },
};

/* eslint-disable no-shadow, no-param-reassign, arrow-body-style */
const actions = {
  fetch: async ({ commit }) => {
    const response = await Vue.http.get("/brands");

    commit("setData", response.body.data);
  },

  getData: async ({ dispatch, state }) => {
    const now = new Date();

    if (!state.data.expiry || now.getTime() > state.data.expiry) {
      await dispatch("fetch");
    }

    return state.data.value;
  },
};

const mutations = {
  setData(state, payload, ttl) {
    if (ttl === undefined) {
      ttl = 60 * 1000; // 1 minute default
    }

    const now = new Date();

    state.data = {
      value: payload,
      expiry: now.getTime() + ttl,
    };
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
